export interface PmfEntry {
  value: number;
  prob: number;
}

export type Pmf = readonly PmfEntry[];

export function pmfExpectation(pmf: Pmf): number {
  let acc = 0;
  for (const e of pmf) acc += e.value * e.prob;
  return acc;
}

export function pmfVariance(pmf: Pmf): number {
  const mu = pmfExpectation(pmf);
  let acc = 0;
  for (const e of pmf) acc += e.value * e.value * e.prob;
  return Math.max(0, acc - mu * mu);
}

export function pmfStdev(pmf: Pmf): number {
  return Math.sqrt(pmfVariance(pmf));
}

export function pmfNormalize(pmf: Pmf): Pmf {
  const total = pmf.reduce((acc, e) => acc + e.prob, 0);
  if (total <= 0) return pmf.map((e) => ({ ...e, prob: 0 }));
  return pmf.map((e) => ({ value: e.value, prob: e.prob / total }));
}
